import React from "react";
import * as C from "./Footer.styles.js";

import LinkedIn from "../../assets/icons/Footer/LinkedInIcon.svg";
import GitHub from "../../assets/icons/Footer/GitHubIcon.svg";
import Instagram from "../../assets/icons/Footer/InstagramIcon.svg";
import Gmail from "../../assets/icons/Footer/GmailIcon.svg";
import Whatsapp from "../../assets/icons/Footer/WhatsAppIcon.svg";

const Footer = () => {
    return (
        <C.FooterContainer>
            <C.TopSection>
                <C.SocialMedia>
                    <a href="https://www.instagram.com/rotta_pizzariadelivery/" target="_blank" rel="noopener noreferrer">
                        <C.SocialMediaIcon src={Instagram} alt="Instagram" />
                    </a>         
                    <a href="https://wa.me/5566999380118" target="_blank" rel="noopener noreferrer">
                        <C.SocialMediaIcon src={Whatsapp} alt="WhatsApp" />
                    </a>    
                </C.SocialMedia>
            </C.TopSection>

            <C.BottomSection>
                <C.FooterInformation>
                    © Rota Pizzaria Delivery 2025 – Todos os direitos reservados
                </C.FooterInformation>
                <C.FooterDeveloperInformation>
                    Desenvolvido por <a href="https://github.com/AmandaE19" target="_blank" rel="noopener noreferrer">Amanda Emidio da Luz</a>
                </C.FooterDeveloperInformation>
                <C.SocialMedia>
                    <a href="https://www.linkedin.com/in/amanda-emidio" target="_blank" rel="noopener noreferrer">
                        <C.DeveloperSocialMediaIcon src={LinkedIn} alt="LinkedIn" />
                    </a>
                    <a href="https://github.com/AmandaE19" target="_blank" rel="noopener noreferrer">
                        <C.DeveloperSocialMediaIcon src={GitHub} alt="GitHub" />
                    </a>
                    <a href="mailto:amanda.emidio.557@gmail.com">
                        <C.DeveloperSocialMediaIcon src={Gmail} alt="Gmail" />
                    </a>
                </C.SocialMedia>
            </C.BottomSection>
        </C.FooterContainer>
    );
};

export default Footer;
